<template>
  <div class="homebase-background">
    <loading-overlay v-if="!showSearchComponent"></loading-overlay>
    <transition name="fade">
      <div>
        <div><outage-banner-card></outage-banner-card></div>
        <div><campaign-card /></div>
        <div class="search-wrapper" :class="{ 'search-results-visible' :toggleHomepageContent }">
          <enterprise-search
            :env="appEnv"
            :es-user-access-token="authResponse.accessToken"
            :es-user-id-token="authResponse.idToken"
            :enable-url-params="false"
            :disable-filters="false"
            :user-id="authResponse.user.userName"
            :user-email="authResponse.user.email"
            @onSearchKeywordChanged="searchKeywordChanged"
            @onWebComponentSuccess="onESComponentReady"
            @onWebComponentError="onESComponentError"
            :key="componentKey"
            :input-placeholder="'Find answers, applications, articles, news and more...'"
            :customize-search="true"
            :enable-employee-hub-search="true"
          ></enterprise-search>
        </div>
        <div class="homebase-container container" v-show="!toggleHomepageContent">
          <homebase-home />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { safeImportComponent } from "@/utils/componentImportUtils";
import { mapGetters, mapMutations, mapActions } from "vuex";
import * as CONSTANTS from "@/store/constants";
import UtilityMixin from "../../mixins/globalUtilityMixin";
import LoadingOverlay from "@/components/LoadingOverlay";

import HomebaseHome from "@/components/homebase/HomebaseHome";
import CampaignCard from "../homebase/CampaignCard";
import OutageBannerCard from "../homebase/OutageBannerCard";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";

export default {
  name: "HomePage",
  mixins: [UtilityMixin, HomebaseMixpanelMixin],
  components: {
    CampaignCard,
    LoadingOverlay,
    HomebaseHome,
    OutageBannerCard 
  },
  computed: {
    ...mapGetters([
      "user",
      "authResponse",
      "isLoading",
      "userCriteria",
    ]),
    showSearchComponent() {
      return this.isSearchComponentReady;
    },
  },
  data() {
    return {
      searchTerm: "",
      appEnv: CURRENT_ENV,
      CONSTANTS,
      componentKey: 0,
      isSearchComponentReady: false,
      toggleHomepageContent: false,
    };
  },
  created() {
    safeImportComponent(ES_COMPONENTS_URL + "/enterprisesearch.umd.min.js");
    this.$nextTick(() => {
      this.componentKey++;
    });

    this.trackAutodeskOnePageHit("Home");
  },
  mounted() {},
  methods: {
    ...mapActions([
      "fetchUserCriteria",
    ]),
    ...mapMutations(["setSearchReady"]),
    onESComponentReady() {
      this.isSearchComponentReady = true;
      this.setSearchReady(true);
    },
    onESComponentError() {
      this.onESComponentReady();
    },
    searchKeywordChanged(response) {
      if (response && response.detail[0]) {
        this.toggleHomepageContent = true;
      } else {
        this.toggleHomepageContent = false;
      }
    }

  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 1s;
  transition-property: opacity;
  transition-timing-function: ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.lumi-img {
  height: 60px;
  margin: -10px 0 -18px -8px;
}
</style>

<style>
.homebase-background {
  background: #f5f5f5 !important;
}
.search-wrapper {
  margin-top: -56px;
  min-height: 136px;
}
.search-results-visible {
  min-height: 70vh !important;
}
.search-results-stats-card-txt {
  color: #666 !important;
}
body:has(.homebase-background) .aone-footer-wrapper {
  background: #f5f5f5 !important;
}
</style>

<style scoped>
/* search placeholder styling */
.search-wrapper >>> .search-input::placeholder {
 color: #cccccc !important;
}
/* alignment fixes */
.search-wrapper >>> .search-card-container {
  -ms-flex: 0 0 100%;
  -webkit-box-flex: 0;
  flex: 0 0 100%;
  max-width: 100%;
  margin-left: 0%;
}
.search-wrapper >>> .nav-bar-wrapper {
  max-width: 1320px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
.search-wrapper >>> .nav-bar-wrapper > .col-md-6 {
  -ms-flex: 0 0 100%;
  -webkit-box-flex: 0;
  flex: 0 0 100%;
  max-width: 100%;
  margin-left: 0%;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.search-wrapper >>> nav {
  background: white !important;
}
.search-wrapper >>> .bg-white {
  width: 100%;
  background: none !important;
}
.search-wrapper >>> .bg-white + .row {
  max-width: 1320px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  background: none !important;
}
.search-wrapper >>> .search-input-wrapper {
  max-width: 1320px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
.search-wrapper >>> .search-card-container > .row {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.search-wrapper >>> .search-card-container:has(.search-results-loading-panel) {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
</style>

<style scoped src="../../../static/aone-theme.css"></style>



// WEBPACK FOOTER //
// src/components/homepage/HomePage.vue